// This class contains form mapping logic for preneed agreement form
// getFormMappings() would return an array of FoxIt fields with the corresponding value
import { FormMapping } from './FormMapping'

export default class SecondaryAddresseeForm extends FormMapping {
	constructor(planHolderId: string) {
		super(planHolderId)
	}

	getFormMappings() {
		return [...this.getPolicyOwnerMapping()]
	}
}
